import { NgFor, NgIf } from "@angular/common";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { IntlService } from "@progress/kendo-angular-intl";
import * as CryptoJS from "crypto-js";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { TransactionsServices } from "../../../@theme/services/transactions.service";
import { RvFieldBuilderComponent } from "../Rvfieldbuilder/rvfield-builder.component";
@Component({
    selector: "gd-rv-step3-new-form",
    styleUrls: ["./Rvstep3Newaccount.component.css"],
    template: `
    <form
      (ngSubmit)="submitNewAccEvent.emit(this.form.value)"
      [formGroup]="form"
      class="form-horizontal"
    >
      <div *ngFor="let field of fields">
        <gd-rvfield-builder
          [field]="field"
          [form]="form"
          [clientId]="clientId"
          *ngIf="field.label !== null"
        ></gd-rvfield-builder>
      </div>
      <div class="flex justify-end mt-4 pr-4">
        <button
          type="submit"
          [disabled]="btnenabled"
          class="px-5 py-2 text-sm font-semibold rounded-md border border-gray-400 bg-white text-gray-700 shadow-sm hover:bg-gray-50 hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Save
        </button>
      </div>
    </form>
  `,
    imports: [FormsModule, ReactiveFormsModule, NgFor, NgIf, RvFieldBuilderComponent]
})
export class RVStep3NewAccountReviewComponent implements AfterViewInit {
  @Output() submitNewAccEvent = new EventEmitter();
  @Output() stopLoader = new EventEmitter();
  @Output() reviewApprovalStatus = new EventEmitter<boolean>();
  unsubcribe: any;
  @Input() RepSelected: number;
  @Input() ClientSelected: number;
  @Input() productTypeSelected: number;
  @Input() transactionTypeSelected: number;
  @Input() SourceofFundsSelected: number;
  @Input() RepCodeSelected: number;
  @Input() repNamestring: string;
  @Input() repCodestring: string;
  @Input() Clientstring: string;
  @Input() productTypestring: string;
  @Input() stateof: string;
  @Input() transactionTypestring: string;
  @Input() sourceoffundsstring: string;
  @Input() clientthirdlisting: Array<any>;
  @Input() taxen: string;
  public clientlist: any[] = [];
  public fields: any[] = [];
  public value: Date = new Date();
  @Input() LiquidNWTo: string;
  @Input() LiquidNWFrom: string;
  @Input() NetWorthTo: string;
  @Input() NetWorthFrom: string;
  @Input() AnnualIncTo: string;
  @Input() AnnualIncFrom: string;
  private index = 0;
  private getname: string;
  @Input() InvestmentProfileId: number;
  @Input() InvestmentTimeHorizonId: number;
  @Input() LiquidityNeedsId: number;
  @Input() InvObjectiveId: number;

  @Input() InvestDescription: string;
  @Input() InvestmentTimeHorizonDescription: string;
  @Input() ProfileDescription: string;
  @Input() LiquidDescription: string;

  @Input() clientId: number;
  @Input() lblRep: string;
  @Input() dob: Date;
  @Input() Email: string;
  public btnenabled: boolean | true;
  /*   @Output() sendBlotId: string; */
  public blotId: number;
  public sendblot: any;
  public form: UntypedFormGroup;
  constructor(
    private toastrService: ToastrService,
    private transservice: TransactionsServices,
    private route: ActivatedRoute,
    private Intl: IntlService
  ) {
    this.form = new UntypedFormGroup({
      fields: new FormControl(this.fields)
    });
  }
  ngAfterViewInit(): void {
    if (this.route.snapshot.queryParams["Rview"]) {
      this.route.queryParams.subscribe((params) => {
        const getblotterClientId = CryptoJS.AES.decrypt(
          params["Rview"],
          `${environment.securepw}`
        ).toString(CryptoJS.enc.Utf8);
        this.blotId = Number(getblotterClientId);
        this.sendblot = { blotterId: this.blotId };
      });
      this.loadQuestions();
    }
  }
  loadQuestions(): void {
      const storageValue =
        localStorage.getItem("rrolelisted") == undefined
          ? ""
          : localStorage.getItem("rrolelisted");
      const paramTR = CryptoJS.AES.decrypt(
        storageValue,
        environment.securepw
      ).toString(CryptoJS.enc.Utf8);
      const paramsVal = {
        //
        blotterId: this.blotId,
        role: paramTR
      };
      this.btnenabled = false;
      this.transservice
        .GetNewAccountFormReviewQuestions(paramsVal)
        .subscribe((response: any[]) => {
          this.fields = response;
          this.stopLoader.emit(false);
          this.form = new UntypedFormGroup({
            fields: new UntypedFormControl(this.fields)
          });
          const fieldsCtrls = {};
          for (const f of this.fields) {
            let control;

            if (f.required === true) {
              control = new UntypedFormControl(
                f.value || "",
                Validators.required
              );
            } else {
              control = new UntypedFormControl(f.value || "");
            }

            if (f.disabled) {
              this.btnenabled = true;
              control.disable();
            }

            fieldsCtrls[f.name] = control;
          }

          this.form = new UntypedFormGroup(fieldsCtrls);

          // Find the first radio field and watch its value for "Yes" approval
          const firstRadioField = this.fields.find(f => f.type === 'radio');
          if (firstRadioField) {
            const ctrl = this.form.get(firstRadioField.name);
            if (ctrl) {
              // Emit initial status
              this.reviewApprovalStatus.emit(ctrl.value === 'Yes');
              // Watch for changes
              ctrl.valueChanges.subscribe(val => {
                this.reviewApprovalStatus.emit(val === 'Yes');
              });
            }
          } else {
            this.reviewApprovalStatus.emit(false);
          }
        });
  }
  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
        this.getname = name;
        this.showToast(0);
      }
    }
    return invalid;
  }
  showToast(duration) {
    this.toastrService.show(this.getname, `You are missing a value :`);
  }
  ngDestroy() {
    this.unsubcribe();
    this.unsub();
  }
  unsub() {
    this.unsubcribe = this.form.valueChanges.subscribe((update) => {
      this.fields = update.fields;
    });
  }
}
